module.exports = __webpack_public_path__ + "static/code-3a4040aae4334edad174f72ab015590e.png";